import { render } from "./ViewKitchenOrders.vue?vue&type=template&id=5afaa367&scoped=true"
import script from "./ViewKitchenOrders.vue?vue&type=script&lang=js"
export * from "./ViewKitchenOrders.vue?vue&type=script&lang=js"

import "./ViewKitchenOrders.vue?vue&type=style&index=0&id=5afaa367&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\php\\Resturant-POS-PHP-VUE-MODULE\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5afaa367"]])

export default __exports__